import React, { forwardRef } from "react";

interface Props {
  value?: string;
  onClick?: () => void;
  placeholder?: string;
  icon?: React.ReactNode;
  error?: boolean;
}

const CustomDateInput = forwardRef<HTMLInputElement, Props>(
  ({ value, onClick, placeholder, icon, error }, ref) => {
    return (
      <div
        onClick={onClick}
        style={{
          display: "flex",
          alignItems: "center",
          border: `1px solid ${error ? "#d32f2f" : "#bfc0c2"}`,
          borderRadius: "4px",
          padding: "5px 10px",
          height: "29px",
          cursor: "pointer",
        }}
      >
        <input
          ref={ref}
          value={value}
          onChange={() => {}}
          placeholder={placeholder}
          style={{
            border: "none",
            outline: "none",
            width: "100%",
            fontSize: "14px",
            color: "#104145",
            background: "transparent",
          }}
        />
        {icon && <span style={{ marginLeft: "8px" }}>{icon}</span>}
      </div>
    );
  }
);

export default CustomDateInput;
